/* eslint-disable */

export const protobufPackage = "od_protos.journey.data.categories";

export interface SellWithUpsideCategory {
  event?:
    | { $case: "qualification"; qualification: SellWithUpsideCategory_QualificationEvent }
    | { $case: "upfrontCashChange"; upfrontCashChange: SellWithUpsideCategory_UpfrontCashChangeEvent }
    | {
      $case: "estimatedSalesPriceChange";
      estimatedSalesPriceChange: SellWithUpsideCategory_EstimatedSalesPriceChangeEvent;
    }
    | { $case: "pricingOptionsLoaded"; pricingOptionsLoaded: SellWithUpsideCategory_PricingOptionsLoadedEvent }
    | undefined;
}

export interface SellWithUpsideCategory_QualificationEvent {
  sellerLeadUuid: string;
  qualificationDecision: SellWithUpsideCategory_QualificationEvent_QualificationDecision;
  denialReason?: string | undefined;
  offerUuid: string;
  addressUuid: string;
  sellerInputId: string;
}

export enum SellWithUpsideCategory_QualificationEvent_QualificationDecision {
  UNKNOWN = 0,
  PRODUCT_QUALIFIED = 1,
  PRODUCT_DENIED = 2,
  PRODUCT_UNDENIED = 3,
  UNRECOGNIZED = -1,
}

export function sellWithUpsideCategory_QualificationEvent_QualificationDecisionFromJSON(
  object: any,
): SellWithUpsideCategory_QualificationEvent_QualificationDecision {
  switch (object) {
    case 0:
    case "UNKNOWN":
      return SellWithUpsideCategory_QualificationEvent_QualificationDecision.UNKNOWN;
    case 1:
    case "PRODUCT_QUALIFIED":
      return SellWithUpsideCategory_QualificationEvent_QualificationDecision.PRODUCT_QUALIFIED;
    case 2:
    case "PRODUCT_DENIED":
      return SellWithUpsideCategory_QualificationEvent_QualificationDecision.PRODUCT_DENIED;
    case 3:
    case "PRODUCT_UNDENIED":
      return SellWithUpsideCategory_QualificationEvent_QualificationDecision.PRODUCT_UNDENIED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return SellWithUpsideCategory_QualificationEvent_QualificationDecision.UNRECOGNIZED;
  }
}

export function sellWithUpsideCategory_QualificationEvent_QualificationDecisionToJSON(
  object: SellWithUpsideCategory_QualificationEvent_QualificationDecision,
): string {
  switch (object) {
    case SellWithUpsideCategory_QualificationEvent_QualificationDecision.UNKNOWN:
      return "UNKNOWN";
    case SellWithUpsideCategory_QualificationEvent_QualificationDecision.PRODUCT_QUALIFIED:
      return "PRODUCT_QUALIFIED";
    case SellWithUpsideCategory_QualificationEvent_QualificationDecision.PRODUCT_DENIED:
      return "PRODUCT_DENIED";
    case SellWithUpsideCategory_QualificationEvent_QualificationDecision.PRODUCT_UNDENIED:
      return "PRODUCT_UNDENIED";
    case SellWithUpsideCategory_QualificationEvent_QualificationDecision.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface SellWithUpsideCategory_UpfrontCashChangeEvent {
  sellerLeadUuid: string;
  offerUuid: string;
  newUpfrontCashCents: number;
  oldUpfrontCashCents: number;
  changeCents: number;
  pricingUuid: string;
}

export interface SellWithUpsideCategory_EstimatedSalesPriceChangeEvent {
  sellerLeadUuid: string;
  offerUuid: string;
  newEstimatedSalesPriceCents: number;
  oldEstimatedSalesPriceCents: number;
  changeCents: number;
  opendoorEstimatedSalesPriceCents: number;
}

export interface SellWithUpsideCategory_PricingOptionsLoadedEvent {
  sellerLeadUuid: string;
  offerUuid: string;
  pricingUuids: string[];
  recommendedPricingUuid: string;
}

function createBaseSellWithUpsideCategory(): SellWithUpsideCategory {
  return { event: undefined };
}

export const SellWithUpsideCategory = {
  fromJSON(object: any): SellWithUpsideCategory {
    return {
      event: isSet(object.qualification)
        ? {
          $case: "qualification",
          qualification: SellWithUpsideCategory_QualificationEvent.fromJSON(object.qualification),
        }
        : isSet(object.upfrontCashChange)
        ? {
          $case: "upfrontCashChange",
          upfrontCashChange: SellWithUpsideCategory_UpfrontCashChangeEvent.fromJSON(object.upfrontCashChange),
        }
        : isSet(object.estimatedSalesPriceChange)
        ? {
          $case: "estimatedSalesPriceChange",
          estimatedSalesPriceChange: SellWithUpsideCategory_EstimatedSalesPriceChangeEvent.fromJSON(
            object.estimatedSalesPriceChange,
          ),
        }
        : isSet(object.pricingOptionsLoaded)
        ? {
          $case: "pricingOptionsLoaded",
          pricingOptionsLoaded: SellWithUpsideCategory_PricingOptionsLoadedEvent.fromJSON(object.pricingOptionsLoaded),
        }
        : undefined,
    };
  },

  toJSON(message: SellWithUpsideCategory): unknown {
    const obj: any = {};
    if (message.event?.$case === "qualification") {
      obj.qualification = SellWithUpsideCategory_QualificationEvent.toJSON(message.event.qualification);
    }
    if (message.event?.$case === "upfrontCashChange") {
      obj.upfrontCashChange = SellWithUpsideCategory_UpfrontCashChangeEvent.toJSON(message.event.upfrontCashChange);
    }
    if (message.event?.$case === "estimatedSalesPriceChange") {
      obj.estimatedSalesPriceChange = SellWithUpsideCategory_EstimatedSalesPriceChangeEvent.toJSON(
        message.event.estimatedSalesPriceChange,
      );
    }
    if (message.event?.$case === "pricingOptionsLoaded") {
      obj.pricingOptionsLoaded = SellWithUpsideCategory_PricingOptionsLoadedEvent.toJSON(
        message.event.pricingOptionsLoaded,
      );
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SellWithUpsideCategory>, I>>(base?: I): SellWithUpsideCategory {
    return SellWithUpsideCategory.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SellWithUpsideCategory>, I>>(object: I): SellWithUpsideCategory {
    const message = createBaseSellWithUpsideCategory();
    if (
      object.event?.$case === "qualification" &&
      object.event?.qualification !== undefined &&
      object.event?.qualification !== null
    ) {
      message.event = {
        $case: "qualification",
        qualification: SellWithUpsideCategory_QualificationEvent.fromPartial(object.event.qualification),
      };
    }
    if (
      object.event?.$case === "upfrontCashChange" &&
      object.event?.upfrontCashChange !== undefined &&
      object.event?.upfrontCashChange !== null
    ) {
      message.event = {
        $case: "upfrontCashChange",
        upfrontCashChange: SellWithUpsideCategory_UpfrontCashChangeEvent.fromPartial(object.event.upfrontCashChange),
      };
    }
    if (
      object.event?.$case === "estimatedSalesPriceChange" &&
      object.event?.estimatedSalesPriceChange !== undefined &&
      object.event?.estimatedSalesPriceChange !== null
    ) {
      message.event = {
        $case: "estimatedSalesPriceChange",
        estimatedSalesPriceChange: SellWithUpsideCategory_EstimatedSalesPriceChangeEvent.fromPartial(
          object.event.estimatedSalesPriceChange,
        ),
      };
    }
    if (
      object.event?.$case === "pricingOptionsLoaded" &&
      object.event?.pricingOptionsLoaded !== undefined &&
      object.event?.pricingOptionsLoaded !== null
    ) {
      message.event = {
        $case: "pricingOptionsLoaded",
        pricingOptionsLoaded: SellWithUpsideCategory_PricingOptionsLoadedEvent.fromPartial(
          object.event.pricingOptionsLoaded,
        ),
      };
    }
    return message;
  },
};

function createBaseSellWithUpsideCategory_QualificationEvent(): SellWithUpsideCategory_QualificationEvent {
  return {
    sellerLeadUuid: "",
    qualificationDecision: 0,
    denialReason: undefined,
    offerUuid: "",
    addressUuid: "",
    sellerInputId: "",
  };
}

export const SellWithUpsideCategory_QualificationEvent = {
  fromJSON(object: any): SellWithUpsideCategory_QualificationEvent {
    return {
      sellerLeadUuid: isSet(object.sellerLeadUuid) ? String(object.sellerLeadUuid) : "",
      qualificationDecision: isSet(object.qualificationDecision)
        ? sellWithUpsideCategory_QualificationEvent_QualificationDecisionFromJSON(object.qualificationDecision)
        : 0,
      denialReason: isSet(object.denialReason) ? String(object.denialReason) : undefined,
      offerUuid: isSet(object.offerUuid) ? String(object.offerUuid) : "",
      addressUuid: isSet(object.addressUuid) ? String(object.addressUuid) : "",
      sellerInputId: isSet(object.sellerInputId) ? String(object.sellerInputId) : "",
    };
  },

  toJSON(message: SellWithUpsideCategory_QualificationEvent): unknown {
    const obj: any = {};
    if (message.sellerLeadUuid !== "") {
      obj.sellerLeadUuid = message.sellerLeadUuid;
    }
    if (message.qualificationDecision !== 0) {
      obj.qualificationDecision = sellWithUpsideCategory_QualificationEvent_QualificationDecisionToJSON(
        message.qualificationDecision,
      );
    }
    if (message.denialReason !== undefined) {
      obj.denialReason = message.denialReason;
    }
    if (message.offerUuid !== "") {
      obj.offerUuid = message.offerUuid;
    }
    if (message.addressUuid !== "") {
      obj.addressUuid = message.addressUuid;
    }
    if (message.sellerInputId !== "") {
      obj.sellerInputId = message.sellerInputId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SellWithUpsideCategory_QualificationEvent>, I>>(
    base?: I,
  ): SellWithUpsideCategory_QualificationEvent {
    return SellWithUpsideCategory_QualificationEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SellWithUpsideCategory_QualificationEvent>, I>>(
    object: I,
  ): SellWithUpsideCategory_QualificationEvent {
    const message = createBaseSellWithUpsideCategory_QualificationEvent();
    message.sellerLeadUuid = object.sellerLeadUuid ?? "";
    message.qualificationDecision = object.qualificationDecision ?? 0;
    message.denialReason = object.denialReason ?? undefined;
    message.offerUuid = object.offerUuid ?? "";
    message.addressUuid = object.addressUuid ?? "";
    message.sellerInputId = object.sellerInputId ?? "";
    return message;
  },
};

function createBaseSellWithUpsideCategory_UpfrontCashChangeEvent(): SellWithUpsideCategory_UpfrontCashChangeEvent {
  return {
    sellerLeadUuid: "",
    offerUuid: "",
    newUpfrontCashCents: 0,
    oldUpfrontCashCents: 0,
    changeCents: 0,
    pricingUuid: "",
  };
}

export const SellWithUpsideCategory_UpfrontCashChangeEvent = {
  fromJSON(object: any): SellWithUpsideCategory_UpfrontCashChangeEvent {
    return {
      sellerLeadUuid: isSet(object.sellerLeadUuid) ? String(object.sellerLeadUuid) : "",
      offerUuid: isSet(object.offerUuid) ? String(object.offerUuid) : "",
      newUpfrontCashCents: isSet(object.newUpfrontCashCents) ? Number(object.newUpfrontCashCents) : 0,
      oldUpfrontCashCents: isSet(object.oldUpfrontCashCents) ? Number(object.oldUpfrontCashCents) : 0,
      changeCents: isSet(object.changeCents) ? Number(object.changeCents) : 0,
      pricingUuid: isSet(object.pricingUuid) ? String(object.pricingUuid) : "",
    };
  },

  toJSON(message: SellWithUpsideCategory_UpfrontCashChangeEvent): unknown {
    const obj: any = {};
    if (message.sellerLeadUuid !== "") {
      obj.sellerLeadUuid = message.sellerLeadUuid;
    }
    if (message.offerUuid !== "") {
      obj.offerUuid = message.offerUuid;
    }
    if (message.newUpfrontCashCents !== 0) {
      obj.newUpfrontCashCents = Math.round(message.newUpfrontCashCents);
    }
    if (message.oldUpfrontCashCents !== 0) {
      obj.oldUpfrontCashCents = Math.round(message.oldUpfrontCashCents);
    }
    if (message.changeCents !== 0) {
      obj.changeCents = Math.round(message.changeCents);
    }
    if (message.pricingUuid !== "") {
      obj.pricingUuid = message.pricingUuid;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SellWithUpsideCategory_UpfrontCashChangeEvent>, I>>(
    base?: I,
  ): SellWithUpsideCategory_UpfrontCashChangeEvent {
    return SellWithUpsideCategory_UpfrontCashChangeEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SellWithUpsideCategory_UpfrontCashChangeEvent>, I>>(
    object: I,
  ): SellWithUpsideCategory_UpfrontCashChangeEvent {
    const message = createBaseSellWithUpsideCategory_UpfrontCashChangeEvent();
    message.sellerLeadUuid = object.sellerLeadUuid ?? "";
    message.offerUuid = object.offerUuid ?? "";
    message.newUpfrontCashCents = object.newUpfrontCashCents ?? 0;
    message.oldUpfrontCashCents = object.oldUpfrontCashCents ?? 0;
    message.changeCents = object.changeCents ?? 0;
    message.pricingUuid = object.pricingUuid ?? "";
    return message;
  },
};

function createBaseSellWithUpsideCategory_EstimatedSalesPriceChangeEvent(): SellWithUpsideCategory_EstimatedSalesPriceChangeEvent {
  return {
    sellerLeadUuid: "",
    offerUuid: "",
    newEstimatedSalesPriceCents: 0,
    oldEstimatedSalesPriceCents: 0,
    changeCents: 0,
    opendoorEstimatedSalesPriceCents: 0,
  };
}

export const SellWithUpsideCategory_EstimatedSalesPriceChangeEvent = {
  fromJSON(object: any): SellWithUpsideCategory_EstimatedSalesPriceChangeEvent {
    return {
      sellerLeadUuid: isSet(object.sellerLeadUuid) ? String(object.sellerLeadUuid) : "",
      offerUuid: isSet(object.offerUuid) ? String(object.offerUuid) : "",
      newEstimatedSalesPriceCents: isSet(object.newEstimatedSalesPriceCents)
        ? Number(object.newEstimatedSalesPriceCents)
        : 0,
      oldEstimatedSalesPriceCents: isSet(object.oldEstimatedSalesPriceCents)
        ? Number(object.oldEstimatedSalesPriceCents)
        : 0,
      changeCents: isSet(object.changeCents) ? Number(object.changeCents) : 0,
      opendoorEstimatedSalesPriceCents: isSet(object.opendoorEstimatedSalesPriceCents)
        ? Number(object.opendoorEstimatedSalesPriceCents)
        : 0,
    };
  },

  toJSON(message: SellWithUpsideCategory_EstimatedSalesPriceChangeEvent): unknown {
    const obj: any = {};
    if (message.sellerLeadUuid !== "") {
      obj.sellerLeadUuid = message.sellerLeadUuid;
    }
    if (message.offerUuid !== "") {
      obj.offerUuid = message.offerUuid;
    }
    if (message.newEstimatedSalesPriceCents !== 0) {
      obj.newEstimatedSalesPriceCents = Math.round(message.newEstimatedSalesPriceCents);
    }
    if (message.oldEstimatedSalesPriceCents !== 0) {
      obj.oldEstimatedSalesPriceCents = Math.round(message.oldEstimatedSalesPriceCents);
    }
    if (message.changeCents !== 0) {
      obj.changeCents = Math.round(message.changeCents);
    }
    if (message.opendoorEstimatedSalesPriceCents !== 0) {
      obj.opendoorEstimatedSalesPriceCents = Math.round(message.opendoorEstimatedSalesPriceCents);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SellWithUpsideCategory_EstimatedSalesPriceChangeEvent>, I>>(
    base?: I,
  ): SellWithUpsideCategory_EstimatedSalesPriceChangeEvent {
    return SellWithUpsideCategory_EstimatedSalesPriceChangeEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SellWithUpsideCategory_EstimatedSalesPriceChangeEvent>, I>>(
    object: I,
  ): SellWithUpsideCategory_EstimatedSalesPriceChangeEvent {
    const message = createBaseSellWithUpsideCategory_EstimatedSalesPriceChangeEvent();
    message.sellerLeadUuid = object.sellerLeadUuid ?? "";
    message.offerUuid = object.offerUuid ?? "";
    message.newEstimatedSalesPriceCents = object.newEstimatedSalesPriceCents ?? 0;
    message.oldEstimatedSalesPriceCents = object.oldEstimatedSalesPriceCents ?? 0;
    message.changeCents = object.changeCents ?? 0;
    message.opendoorEstimatedSalesPriceCents = object.opendoorEstimatedSalesPriceCents ?? 0;
    return message;
  },
};

function createBaseSellWithUpsideCategory_PricingOptionsLoadedEvent(): SellWithUpsideCategory_PricingOptionsLoadedEvent {
  return { sellerLeadUuid: "", offerUuid: "", pricingUuids: [], recommendedPricingUuid: "" };
}

export const SellWithUpsideCategory_PricingOptionsLoadedEvent = {
  fromJSON(object: any): SellWithUpsideCategory_PricingOptionsLoadedEvent {
    return {
      sellerLeadUuid: isSet(object.sellerLeadUuid) ? String(object.sellerLeadUuid) : "",
      offerUuid: isSet(object.offerUuid) ? String(object.offerUuid) : "",
      pricingUuids: Array.isArray(object?.pricingUuids)
        ? object.pricingUuids.map((e: any) => String(e))
        : [],
      recommendedPricingUuid: isSet(object.recommendedPricingUuid) ? String(object.recommendedPricingUuid) : "",
    };
  },

  toJSON(message: SellWithUpsideCategory_PricingOptionsLoadedEvent): unknown {
    const obj: any = {};
    if (message.sellerLeadUuid !== "") {
      obj.sellerLeadUuid = message.sellerLeadUuid;
    }
    if (message.offerUuid !== "") {
      obj.offerUuid = message.offerUuid;
    }
    if (message.pricingUuids?.length) {
      obj.pricingUuids = message.pricingUuids;
    }
    if (message.recommendedPricingUuid !== "") {
      obj.recommendedPricingUuid = message.recommendedPricingUuid;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SellWithUpsideCategory_PricingOptionsLoadedEvent>, I>>(
    base?: I,
  ): SellWithUpsideCategory_PricingOptionsLoadedEvent {
    return SellWithUpsideCategory_PricingOptionsLoadedEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SellWithUpsideCategory_PricingOptionsLoadedEvent>, I>>(
    object: I,
  ): SellWithUpsideCategory_PricingOptionsLoadedEvent {
    const message = createBaseSellWithUpsideCategory_PricingOptionsLoadedEvent();
    message.sellerLeadUuid = object.sellerLeadUuid ?? "";
    message.offerUuid = object.offerUuid ?? "";
    message.pricingUuids = object.pricingUuids?.map((e) => e) || [];
    message.recommendedPricingUuid = object.recommendedPricingUuid ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Array<infer U> ? Array<DeepPartial<U>> : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string } ? { [K in keyof Omit<T, "$case">]?: DeepPartial<T[K]> } & { $case: T["$case"] }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
